export const sxConfig = {
  container: {
    background: '#EBECF0',
    cursor: 'pointer',
    borderRadius: '8px',
    transition: '.3s',
    '&:hover': {
      background: '#d8d9dd',
      transition: '.3s',
    },
  },

  inputWrapper: {
    padding: '0.5rem',
  },

  placeholderText: {
    color: '#607d8b',
    fontWeight: 'bold',
  },

  buttonWrapper: {
    display: 'flex',
    gap: '0.5rem',
  },

  root: {
    marginTop: '1rem',
  },

  row: {
    display: 'flex',
    gap: '0.3rem',
  },

  avatar: {
    bgcolor: '#669DF1',
    width: 32,
    height: 32,
    fontSize: '1rem',
  },

  contentWrapper: {
    width: '100%',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0rem 0.5rem',
    marginBottom: 0.5,
  },

  userName: {
    fontWeight: 'bold',
    color: '#607d8b',
  },

  date: {
    fontSize: '12px',
    textDecoration: 'underline',
    color: '#669DF1',
  },

  edited: {
    fontSize: '12px',
    color: '#949494',
  },

  messageBox: {
    background: '#EBECF0',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
  },

  messageBoxText: {
    padding: '0.5rem',
    whiteSpace: 'pre-wrap',
  },

  actions: {
    marginTop: '0.2rem',
    display: 'flex',
    gap: '0.5rem',
    textDecoration: 'underline',
  },

  actionText: {
    fontSize: '13px',
    cursor: 'pointer',
  },
};
